var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-breadcrumb", {
        attrs: {
          items: [
            { text: "Pricing Plans", path: { name: "admin-pricing-plans" } },
          ],
          name: "New Plan",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-footer": "", "sub-title": "Pricing Plan Data" },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.formState.processing,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.submitPricingPlan.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v("\n        Submit New Plan\n        "),
                      _vm.formState.processing
                        ? _c("b-spinner", {
                            staticClass: "ml-1",
                            attrs: { small: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("admin-pricing-plan-form", {
            attrs: { validation: _vm.formValidation },
            model: {
              value: _vm.formData,
              callback: function ($$v) {
                _vm.formData = $$v
              },
              expression: "formData",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }